export const MenuType = {
  SIDEBAR: "sidebar",
  MAINMENU: "mainMenu",
  HIDEMAINMENU: "hideMainMenu",
  SUBMENU: "subMenu",
};
